<nav class="navbar sticky-top navbar-expand-lg navbar-light">
  <div class="container-fluid">
    <div class="navbar-logo-div navbar-brand">
      <span class="material-icons navbar-logo-img">track_changes</span>
      <span class="navbar-title title">{{ 'MENU.TITLE' | translate | uppercase }}</span>
    </div>
    <div class="image-container" *ngIf="loading">
      <div id="loader-icon" class="spinner-loader m-0 position-static profile-picture"></div>
    </div>
    <ul class="navbar-nav ms-auto ps-2">
      <button class="image-container" *ngIf="!loading" (click)="edit(user())">
        <img
          *ngIf="user().picture !== ''; else defaultProfilePicture"
          (error)="user().picture = ''"
          class="profile-picture"
          [src]="user().picture"
          id="img"
          alt="{{ user().username }}"
        />
        <ng-template #defaultProfilePicture>
          <em class="fa fa-user-circle fa-3x"></em>
        </ng-template>
        <div class="overlay profile-picture">
          <em class="fa-solid fa-pen fa-bounce"></em>
        </div>
      </button>
      <li ngbDropdown class="nav-item dropdown d-flex flex-row pe-3">
        <button
          ngbDropdownToggle
          class="nav-link dropdown-toggle"
          id="account-menu"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          onkeydown=""
        >
          <span>{{ user().firstname }}</span>
          <br />
          <span>{{ user().name }}</span>
        </button>
        <div ngbDropdownMenu class="dropdown-menu-end">
          <a ngbDropdownItem id="dashboard-menu-item" *ngIf="isSuperAdmin" routerLink="/dashboard">
            {{ 'MENU.DASHBOARD' | translate }}
          </a>
          <a ngbDropdownItem id="referencer-menu-item" *ngIf="isReferencer" routerLink="/referencer/home">
            {{ 'MENU.REFERENCER' | translate }}
          </a>
          <a ngbDropdownItem id="contributor-menu-item" *ngIf="isContributor" routerLink="/contributor/home">
            {{ 'MENU.CONTRIBUTOR' | translate }}
          </a>
          <a ngbDropdownItem id="administration-menu-item" *ngIf="isAdmin" routerLink="/admin">{{ 'MENU.ADMINISTRATION' | translate }}</a>
          <div class="dropdown-divider"></div>
          <a ngbDropdownItem id="logout-menu-item" (click)="disconnect()">{{ 'MENU.LOGOUT' | translate }}</a>
        </div>
      </li>
    </ul>
  </div>
</nav>
